/** Illustrations describe the task, never simulated readings or measurements. */
export function ComputerFeatureArt({ kind }: { kind: string }) {
  return (
    <svg className={`computer-feature-art art-${kind}`} viewBox="0 0 180 124" aria-hidden="true">
      {kind === 'extraction' ? (
        <>
          <g className="art-paper" transform="translate(25 10) rotate(-5 40 52)">
            <rect width="77" height="100" rx="5" />
            <path className="art-ink" d="M13 18h28m-28 13h50M13 63h50m-50 13h50m-50 13h31" />
            <rect className="art-highlight" x="10" y="40" width="55" height="13" rx="2" />
          </g>
          <path className="art-link" pathLength="100" d="M88 59h19v-27h12m-12 27v31h12" />
          <g className="art-paper">
            <rect x="113" y="19" width="52" height="25" rx="5" />
            <rect x="113" y="77" width="52" height="25" rx="5" />
          </g>
          <path className="art-value" d="M123 31h29m-29 58h21" />
        </>
      ) : kind === 'ocr' ? (
        <>
          <g className="art-paper">
            <rect x="44" y="11" width="91" height="102" rx="5" />
          </g>
          <path className="art-ink" d="M59 29h54M59 46h45m-45 17h54M59 80h54m-54 17h35" />
          <rect className="art-highlight" x="54" y="37" width="65" height="17" rx="2" />
          <path className="art-scan" d="M30 55h120" />
          <g className="art-magnifier" transform="translate(132 81)">
            <circle r="18" />
            <path d="m13 13 17 17" />
          </g>
        </>
      ) : kind === 'barcode' ? (
        <>
          <g className="art-paper">
            <rect x="19" y="25" width="142" height="77" rx="7" />
          </g>
          <g className="art-bars">
            {[0, 6, 10, 18, 22, 30, 39, 43, 50, 59, 63, 70, 78, 86, 91, 98].map((x, i) => (
              <rect key={x} x={37 + x} y="43" width={i % 3 === 0 ? 4 : 2} height="34" />
            ))}
          </g>
          <path className="art-ink" d="M48 87h85" />
          <path className="art-scan-corners" d="M27 41V16h27m72 0h27v25M27 90v20h27m72 0h27V90" />
          <path className="art-barcode-scan" d="M90 35v51" />
        </>
      ) : (
        <>
          <g className="art-paper">
            <g className="art-preview-back">
              <rect x="39" y="12" width="79" height="91" rx="5" transform="rotate(-12 78 58)" />
            </g>
            <g className="art-preview-middle">
              <rect x="58" y="12" width="79" height="101" rx="5" transform="rotate(7 97 62)" />
            </g>
            <rect x="47" y="11" width="79" height="101" rx="5" />
          </g>
          <path className="art-ink" d="M60 29h31m-31 58h52m-52 11h40" />
          <rect className="art-highlight" x="60" y="40" width="52" height="35" rx="3" />
          <path className="art-value" d="m65 66 12-12 10 8 8-6 12 11" />
        </>
      )}
    </svg>
  );
}
